export default __webpack_public_path__ + "assets/commercialPictureCompressed.5433aa0c.webp";